import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const DEFAULT_POSITION = "bottom-right";

const getToastOptions = (position = DEFAULT_POSITION) => ({
  position,
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "light",
});

const Toaster = {
  success: (message, position = DEFAULT_POSITION) => {
    toast.success(message, getToastOptions(position));
  },
  error: (message, position = DEFAULT_POSITION) => {
    toast.error(message, getToastOptions(position));
  },
  info: (message, position = DEFAULT_POSITION) => {
    toast.info(message, getToastOptions(position));
  },
  warning: (message, position = DEFAULT_POSITION) => {
    toast.warning(message, getToastOptions(position));
  },
};

export const ToastContainerComponent = ({ position = DEFAULT_POSITION }) => {
  return (
    <ToastContainer
      position={position}
      style={{ zIndex: 10000 }}
    />
  );
};

export default Toaster;
